<template>

  <div class="dynamic-page">
    <template v-if="header && pageWrapper.header">
      <Header :context="header[0]"></Header>
    </template>

    <section v-if="globalMessages && Array.isArray(globalMessages) && globalMessages.length > 0">
      <v-container fluid>
        <v-row>
          <v-col>
            <Messages :messages="globalMessages"></Messages>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <section id="breadcrumbs" v-if="breadcrumbs">
      <v-container>
        <v-row no-gutters>
          <v-col xs="12" sm="12">
            <bread-crumbs :context="breadcrumbs"/>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <template v-if="loaded">
      <section>
        <v-container class="white">
          <page-view v-if="loadedArticle" :context="context">
          </page-view>
        </v-container>
      </section>

    </template>
    <template v-else>
      <v-container class="white dashed-section">
        <v-row>
          <v-col cols="2"></v-col>
          <v-col cols="8" class="py-8">
            <v-skeleton-loader
                type="card-avatar, article, actions, divider,  table-heading, list-item-two-line, image, table-tfoot"></v-skeleton-loader>
          </v-col>
          <v-col cols="2"></v-col>
        </v-row>
      </v-container>

    </template>

    <template v-if="footer && pageWrapper.footer">
      <Footer :context="footer"></Footer>
    </template>

  </div>

</template>

<script>
import Messages from "@/components/Messages";
import Header from "@/views/template/Header";
import BreadCrumbs from "@/views/template/BreadCrumbs";
import Footer from "@/views/template/Footer";
import globalMixins from "@/mixins/globalMixins";
import debounce from "lodash/debounce";
import pageView from "@/views/partials/herbalgramArticlePage.vue";

export default {
  name: 'HerbalGramPage',

  mixins: [globalMixins],

  components: {
    BreadCrumbs,
    Header,
    Footer,
    Messages,
    pageView
  },

  data: () => ({
    globals: {},
    loaded: false,
    loadedArticle: false,
    context: {},
  }),

  props: {
    defaultGlobals: {
      type: Object
    }
  },

  computed: {
    pageWrapper() {
      return {
        header: (process.env.VUE_APP_TYPE && ['website', 'serve'].includes(process.env.VUE_APP_TYPE.toString().toLowerCase())),
        footer: (process.env.VUE_APP_TYPE && ['website', 'serve'].includes(process.env.VUE_APP_TYPE.toString().toLowerCase()))
      }
    }
  },

  async created() {
    await this.setGlobalDefaults();
    await this.loadData();
    await this.init();
  },

  mounted: debounce(function () {
    this.$nextTick(async () => {
      await this.hookAllLinks();
    });
  }, 1000),

  updated: debounce(function () {
    this.$nextTick(async () => {
      await this.hookAllLinks();
    });
  }, 1000),

  methods: {

    async init() {
      this.loadedArticle = true;
    },

    async getPageDate(pageInfo) {
      let issue = pageInfo.paths[3];
      let title = this.stripTags(issue.title).trim();
      let date = title.split(" ");
      let map = {
        "Spring": "04-01",
        "Fall": "10-01",
        "Summer": "07-01",
        "Winter": "12-01"
      }
      pageInfo.datePublished = `${date[1]}-${map[date[0]]}`;
      return;
    },

    async loadData() {
      this.resetPage();
      this.loaded = false;
      let route = this.$router.currentRoute.path;

      let requestOptions = {
        url: '/abcbridgeapi/',
        method: 'post',
        body: {
          route: route,
          meta: {
            "serializeMultiNode": true
          }
        }
      };

      this.$emit('triggerOverlayLoading', true);
      return this.getSendData(requestOptions)
          .then(async (pageInfo) => {
            this.loading = false;
            let myroute = this.$router.currentRoute.path;
            if (pageInfo && pageInfo.error) {
              if ((pageInfo.error === "Access Denied") && (process.env.VUE_APP_TYPE !== "widget")) {
                setTimeout(() => {
                  this.pushMessage({
                    type: 'error',
                    title: pageInfo.error,
                    text: pageInfo.message
                  });
                }, 500);

                this.$router.push(
                    {
                      name: "MemberAccess",
                      query: {page: myroute}
                    }
                );
                // need to login, or upgrade if he is already logged in
              } else {
                if(pageInfo.error === "Page Not Found"){
                  this.$router.push({name: 'error404'});
                }else{
                  setTimeout(() => {
                    this.pushMessage({
                      type: 'error',
                      title: pageInfo.error,
                      text: pageInfo.message
                    });
                  }, 500);
                  this.$router.push({name: "HomePage"});
                }
              }

            } else if (pageInfo) {
              this.resetPage();
              this.pageId = pageInfo.id;
              this.rawPageInfo = pageInfo;

              await this.getPageDate(pageInfo);
              await this.setPageMeta(pageInfo);

              if (pageInfo.sections) {
                this.body = pageInfo.sections;
              }
              this.context = pageInfo;
            }
            this.loaded = true;
            this.$forceUpdate();
            this.$emit('triggerOverlayLoading', false);
          })
          .catch(error => {
            if (error && error.errors && error.errors[132] && error.errors[132].message) {
              this.clearMessages();
              this.licenseError();
            } else {
              if (error && error.errors && error.errors[2001]) {
                this.$router.push({name: 'error404'});
              } else {
                console.error(error);
              }
            }
          });
    },

    triggerRerenderMenu(updatedMenu) {
      this.$emit('rerenderMenu', updatedMenu);
    },

  }
}
</script>
